/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type DefectSeverity = "CRITICAL" | "HIGH" | "LOW" | "MEDIUM" | "%future added value";
export type Defect_status = "ACCEPTED" | "IDENTIFIED" | "IN_REVIEW" | "REJECTED" | "RESOLVED" | "%future added value";
export type Severity = "CRITICAL" | "HIGH" | "LOW" | "MEDIUM" | "%future added value";
export type AnalyzeClipForDefectsInput = {
    inspectionId: string;
    clipIndex: number;
};
export type InspectionPanelAnalyzeClipMutationVariables = {
    input: AnalyzeClipForDefectsInput;
};
export type InspectionPanelAnalyzeClipMutationResponse = {
    readonly analyzeClipForDefects: {
        readonly inspection: {
            readonly id: string;
            readonly defects: ReadonlyArray<{
                readonly id: string;
                readonly title: string;
                readonly description: string;
                readonly severity: Severity;
                readonly defectStatus: Defect_status;
                readonly roomType: string;
                readonly defectCategory: string;
                readonly sourceClipIndex: number;
                readonly sourceFramePosition: string;
                readonly aiDetected: boolean;
                readonly aiConfidence: number;
                readonly evidenceImageURI: string;
                readonly audioStartSeconds: number;
                readonly audioEndSeconds: number;
            }>;
        };
        readonly detectedDefects: ReadonlyArray<{
            readonly title: string;
            readonly description: string;
            readonly severity: DefectSeverity;
            readonly roomType: string | null;
            readonly defectCategory: string | null;
            readonly framePosition: string;
            readonly confidence: number;
        }>;
        readonly createdDefects: ReadonlyArray<{
            readonly id: string;
            readonly title: string;
        }>;
    };
};
export type InspectionPanelAnalyzeClipMutation = {
    readonly response: InspectionPanelAnalyzeClipMutationResponse;
    readonly variables: InspectionPanelAnalyzeClipMutationVariables;
};



/*
mutation InspectionPanelAnalyzeClipMutation(
  $input: AnalyzeClipForDefectsInput!
) {
  analyzeClipForDefects(input: $input) {
    inspection {
      id
      defects {
        id
        title
        description
        severity
        defectStatus
        roomType
        defectCategory
        sourceClipIndex
        sourceFramePosition
        aiDetected
        aiConfidence
        evidenceImageURI
        audioStartSeconds
        audioEndSeconds
      }
    }
    detectedDefects {
      title
      description
      severity
      roomType
      defectCategory
      framePosition
      confidence
    }
    createdDefects {
      id
      title
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "severity",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "roomType",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "defectCategory",
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AnalyzeClipForDefectsPayload",
    "kind": "LinkedField",
    "name": "analyzeClipForDefects",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PropertyInspection",
        "kind": "LinkedField",
        "name": "inspection",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "DefectItem",
            "kind": "LinkedField",
            "name": "defects",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "defectStatus",
                "storageKey": null
              },
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sourceClipIndex",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sourceFramePosition",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "aiDetected",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "aiConfidence",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "evidenceImageURI",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "audioStartSeconds",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "audioEndSeconds",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DetectedDefect",
        "kind": "LinkedField",
        "name": "detectedDefects",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "framePosition",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "confidence",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DefectItem",
        "kind": "LinkedField",
        "name": "createdDefects",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InspectionPanelAnalyzeClipMutation",
    "selections": (v7/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InspectionPanelAnalyzeClipMutation",
    "selections": (v7/*: any*/)
  },
  "params": {
    "cacheID": "3a5d7f95c3e5b3542171619a747b1cf7",
    "id": null,
    "metadata": {},
    "name": "InspectionPanelAnalyzeClipMutation",
    "operationKind": "mutation",
    "text": "mutation InspectionPanelAnalyzeClipMutation(\n  $input: AnalyzeClipForDefectsInput!\n) {\n  analyzeClipForDefects(input: $input) {\n    inspection {\n      id\n      defects {\n        id\n        title\n        description\n        severity\n        defectStatus\n        roomType\n        defectCategory\n        sourceClipIndex\n        sourceFramePosition\n        aiDetected\n        aiConfidence\n        evidenceImageURI\n        audioStartSeconds\n        audioEndSeconds\n      }\n    }\n    detectedDefects {\n      title\n      description\n      severity\n      roomType\n      defectCategory\n      framePosition\n      confidence\n    }\n    createdDefects {\n      id\n      title\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'ff3380f606e2b958ea23ce30712302b5';
export default node;
